import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { AppRoutes } from '../../../routes/routeConstants/appRoutes';
import styles from './homeHeader.module.scss';

const HomeHeader: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate(AppRoutes.MY_PROFILE);
  };

  return (
    <header className={styles.header}>
      <h1 className={styles.welcome}>
        <span>Welcome to</span>
        <span className={styles.organization}>{user?.company ?? user?.name}</span>
        <span>Mapaki,</span>
      </h1>

      <button type="button" className={styles.user} onClick={handleProfileClick} aria-label="Go to my profile">
        <img className={styles.avatar} src={'/assets/user-icon.svg'} alt="" aria-hidden="true" />
        <div className={styles.identity}>
          <span className={styles.name}>{user?.name}</span>
          <span className={styles.role}>{user?.role?.role}</span>
        </div>
      </button>
    </header>
  );
};

export default HomeHeader;
